module.exports = __webpack_public_path__ + "media/images/version_merge/why_money-aefbcc7692c8153f662f6dd15d91d046.svg";